import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Container, Box } from "@mui/material";
import Layout from "../../../layout/Layout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addVideoGallery,
  getVideoGallery,
  editVideoGallery,
} from "../../../services/coworking/videoGalleryAPI";

const AddEditCoworkingVideoGallery = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  let location = useLocation();
  location = location.pathname.slice(1);

  const isEditMode =
    location === "add-new-coworking-video-gallery" ? false : true;

  const [videoGalleryData, setVideoGalleryData] = useState({
    videoUrl: "",
    description: "",
  });

  useEffect(() => {
    if (id) {
      getVideoGallery(id)
        .then((data) => {
          setVideoGalleryData({
            videoUrl: data.video_url,
            description: data.description,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setVideoGalleryData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const newVideoGalleryData = {
      video_url: videoGalleryData.videoUrl,
      description: videoGalleryData.description,
    };
    if (isEditMode) {
      editVideoGallery(id, newVideoGalleryData)
        .then((response) => {
          setVideoGalleryData({
            videoUrl: "",
            description: "",
          });

          navigate("/coworking-photo-gallery");
        })
        .catch((error) => {
          console.error("Greška pri ažuriranju:", error);
        });
    } else {
      addVideoGallery(newVideoGalleryData)
        .then((response) => {
          setVideoGalleryData({
            ...videoGalleryData,
            videoUrl: response.video_url,
            description: response.description,
          });
          navigate("/coworking-photo-gallery");
        })
        .catch((error) => {
          console.error("Greška pri dodavanju", error);
        });
    }
  };

  const handleBack = () => {
    // Handle Back action here
  };

  return (
    <Layout>
      <div>
        <Box style={{ display: "flex" }}>
          <Link
            to="/coworking-video-gallery"
            style={{ textDecoration: "none" }}
          >
            <Button variant="outlined" onClick={handleBack}>
              <ArrowBackIcon />
              Back
            </Button>
          </Link>
        </Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
          Coworking Video Gallery
        </Typography>

        <form onSubmit={handleSubmit}>
          <div>
            <TextField
              sx={{ marginTop: "30px" }}
              name="videoUrl"
              label="Video"
              value={videoGalleryData.videoUrl}
              fullWidth
              onChange={handleInputChange}
            />
          </div>

          <div>
            <TextField
              sx={{ marginTop: "30px" }}
              name="description"
              label="Description"
              value={videoGalleryData.description}
              fullWidth
              onChange={handleInputChange}
            />
          </div>

          <Container
            sx={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              sx={{ m: 1, width: "25ch" }}
              type="submit"
              size="medium"
              variant="outlined"
            >
              {location === "add-new-coworking-video-gallery"
                ? "Publish"
                : "Save"}
            </Button>
          </Container>
        </form>
      </div>
    </Layout>
  );
};

export default AddEditCoworkingVideoGallery;
